export default {"src":"/_next/static/media/whatsapp_logo_170x175.edb9df43.svg","height":175,"width":170,"blurWidth":0,"blurHeight":0};